import React from 'react'

const ErrorMessage = ({ error }) => {
  return (
    <>
        {
			error ?
				<div className='error'>
					{ error }
				</div>
			: ''
		}
    </>
  )
}

export default ErrorMessage